const $card = document.querySelector('.gift-card__card');
let bounds;

function rotateToPoint(x, y) {
  const leftX = x - bounds.x;
  const topY = y - bounds.y;
  const center = {
    x: leftX - bounds.width / 2,
    y: topY - bounds.height / 2,
  };
  const distance = Math.sqrt(center.x ** 2 + center.y ** 2);

  $card.style.transform = `
  scale3d(1.07, 1.07, 1.07)
  rotate3d(
    ${center.y / 100},
    ${-center.x / 100},
    0,
    ${Math.log(distance) * 2}deg
  )
`;

  $card.querySelector('.glow').style.backgroundImage = `
  radial-gradient(
    circle at
    ${center.x * 2 + bounds.width / 2}px
    ${center.y * 2 + bounds.height / 2}px,
    #ffffff55,
    #0000000f
  )
`;
}

function rotateToMouse(e) {
  rotateToPoint(e.clientX, e.clientY);
}

function rotateToTouch(e) {
  if (e.touches.length > 0) {
    const touch = e.touches[0];
    rotateToPoint(touch.clientX, touch.clientY);
  }
}

$card.addEventListener('mouseenter', () => {
  bounds = $card.getBoundingClientRect();
  document.addEventListener('mousemove', rotateToMouse);
});

$card.addEventListener('mouseleave', () => {
  document.removeEventListener('mousemove', rotateToMouse);
  $card.style.transform = '';
  $card.style.background = '';
});

// Touch events for mobile
$card.addEventListener('touchstart', e => {
  bounds = $card.getBoundingClientRect();
  rotateToTouch(e);
  document.addEventListener('touchmove', rotateToTouch);
});

$card.addEventListener('touchend', () => {
  document.removeEventListener('touchmove', rotateToTouch);
  $card.style.transform = '';
  $card.style.background = '';
});

// Animate glow on page load
document.addEventListener('DOMContentLoaded', () => {
  bounds = $card.getBoundingClientRect();
  const centerX = bounds.x + bounds.width / 2;
  const centerY = bounds.y + bounds.height / 2;
  const radius = Math.min(bounds.width, bounds.height) / 4;
  const duration = 1000; // 1 second
  const steps = 60;
  let frame = 0;
  // Add animating class for box-shadow
  $card.classList.add('gift-card__card--animating');
  function animateGlow() {
    if (frame <= steps) {
      const angle = (frame / steps) * 2 * Math.PI;
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);
      rotateToPoint(x, y);
      frame++;
      requestAnimationFrame(animateGlow);
    } else {
      $card.style.transform = '';
      $card.style.background = '';
      // Remove the glow after animation
      const glow = $card.querySelector('.glow');
      if (glow) {
        glow.style.backgroundImage = '';
      }
      // Remove animating class
      $card.classList.remove('gift-card__card--animating');
    }
  }
  animateGlow();
});